<template>
  <div class="text-left bg-white rounded">
    <div class="px-3 pt-3">
    <h3 class="font-weight-bold f-20 mb-3 mt-2 text-left text-black">{{ $t('integrations.title') }}</h3>
    </div>
    <div v-if="!showInnerSamsaraPage && !showInnerMotivePage && !showInnerGeoTabPage && !showInnerIsaacPage && !showInnerPsPage && !showInnerSparklePage && !showInnerOptimaPage">
       <div class="px-3" v-if="!company[0].default_password">
      <div class="documents-progess-section f-14 text-left d-flex align-items-center bg-secondary-2">
      <div class="w-75">
        {{ $t('integrations.defaultPasswordWarning') }}
      </div>
      <p class="mb-0 text-primary cursor-pointer f-14 ml-auto"
        @click="$bvModal.show('modal-set-password-default-drivers')">{{ $t('integrations.clickHere') }}</p>
    </div>
    </div>
    <b-table responsive :fields="translatedFields" :items="items" hover :per-page="perPage"
      :current-page="currentPage" show-empty @row-clicked="goToRoute"
      >
      <template #cell(name)="data">
        <div class="d-flex align-items-center">
          <img v-if="data.item.image" :src="require(`@/assets/${data.item.image}`)" height="48px" />
          <span class="ml-3 f-14 fw-500">{{ data.item.name }}</span>
        </div>
      </template>
      <template #cell(status)="data">
        <span :class="data.item.isActive ? 'badge-success' : 'badge-secondary-2'">{{ data.item.isActive ? $t('integrations.active') : $t('integrations.inactive') }}</span>
      </template>
    </b-table>
    </div>
    <div class="p-3">
    <SamsaraIntegration :status="company[0].is_samsara_integrated" @close="$emit('samsaraStatus', false)"
      v-if="showInnerSamsaraPage" />
    <MotiveIntegration :status="company[0].is_motive_integrated" @close="$emit('motiveStatus', false)"
      v-if="showInnerMotivePage" />
    <GeoTabIntegration v-if="showInnerGeoTabPage" @close="$emit('geoTabStatus', false)"
      :status="company[0].is_geotab_integrated" />
    <IsaacIntegration v-if="showInnerIsaacPage" @close="$emit('isaacStatus', false)"
      :status="company[0].is_isaac_integrated" :showInnerIsaacPage="showInnerIsaacPage" />
    <PSIntegration v-if="showInnerPsPage" @close="$emit('psStatus', false)" :status="company[0].is_ps_integrated" />
    <SparkleIntegration v-if="showInnerSparklePage" @close="$emit('sparkleStatus', false)"
      :status="company[0].is_sparkle_ELD_integrated" />
      <OptimaIntegration v-if="showInnerOptimaPage" @close="$emit('optimaStatus', false)"
      :status="company[0].is_optima_ELD_integrated" />
    <DefaultDriversPasswordPopup />
    </div>
  </div>
</template>
<script>
import SamsaraIntegration from "./SamsaraIntegration.vue";
import MotiveIntegration from "./MotiveIntegration.vue";
import GeoTabIntegration from "./GeoTabIntegration.vue";
import IsaacIntegration from "./IsaacIntegration.vue";
import PSIntegration from "./PSIntegration.vue";
import SparkleIntegration from "./SparkleIntegration.vue";
import OptimaIntegration from "./OptimaIntegration.vue";
import DefaultDriversPasswordPopup from "./DefaultDriversPasswordPopup.vue";
export default {
  name: "Integrations",
  props: ["company", "showInnerGeoTabPage", "showInnerSamsaraPage", "showInnerMotivePage", "showInnerIsaacPage", "showInnerPsPage", "showInnerSparklePage", "showInnerOptimaPage"],
  data() {
    return {
      items: [],
      perPage: 10,
      currentPage: 1
    };
  },
  computed: {
    translatedFields() {
      return [
        { key: "name", sortable: true, label: this.$t('integrations.name'), tdClass: "cursor-pointer", thClass: 'font-table-weight-bold' },
        { key: "status", sortable: true, label: this.$t('integrations.status'), tdClass: "cursor-pointer", thClass: 'font-table-weight-bold' },
      ];
    },
  },
  components: {
    SamsaraIntegration,
    MotiveIntegration,
    GeoTabIntegration,
    IsaacIntegration,
    PSIntegration,
    DefaultDriversPasswordPopup,
    SparkleIntegration,
    OptimaIntegration
  },
  mounted() {
    const c = this.company && this.company[0];
    this.items = [
      {
        name: "Samsara",
        image: "samsara-table.svg",
        isActive: !!(c && c.is_samsara_integrated),
        action: () => this.$emit('samsaraStatus', true)
      },
      {
        name: "Motive",
        image: "motive-table.svg",
        isActive: !!(c && c.is_motive_integrated),
        action: () => this.$emit('motiveStatus', true)
      },
      {
        name: "Platform Science",
        image: "ps-table.svg",
        isActive: !!(c && c.is_ps_integrated),
        action: () => this.$emit('psStatus', true)
      },
      {
        name: "Isaac",
        image: "isaac-table.svg",
        isActive: !!(c && c.is_isaac_integrated),
        action: () => this.$emit('isaacStatus', true)
      },
      {
        name: "Geotab",
        image: "geo-tab-table.svg",
        isActive: !!(c && c.is_geotab_integrated),
        action: () => this.$emit('geoTabStatus', true)
      },
      // {
      //   name: "Sparkle",
      //   image: "sparkle-table.svg",
      //   status: this.company && this.company[0] && this.company[0].is_sparkle_ELD_integrated ? "Active" : "Inactive",
      //   action: () => this.$emit('sparkleStatus', true)
      // },
      // {
      //   name: "Optima",
      //   image: "optima.svg",
      //   status: this.company && this.company[0] && this.company[0].is_optima_ELD_integrated ? "Active" : "Inactive",
      //   action: () => this.$emit('optimaStatus', true)
      // }
    ]
  },
  methods:{
    goToRoute(item) {
      item.action()
    }
  }
};
</script>
<style>
.integration-status {
  position: absolute;
  right: 0;
}

.mt-30-px {
  margin-top: 30px !important;
}

.badge-success {
  background-color: var(--bg-green) !important;
  color: white !important;
  padding: 8px 4px;
  border-radius: 12px;
  font-size: 12px;
  width: 60px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge-secondary-2 {
  background-color: var(--bg-grey) !important;
  color: black !important;
  padding: 8px 4px;
  border-radius: 12px;
  font-size: 12px;
  width: 60px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
